module.exports = __webpack_public_path__ + "media/images/social-share-button/telegram-ca65ba180088505e1371c721ba430b54.svg";